/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, November 23rd 2021, 8:40:29 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { SaaSOnlyWrapper } from "authorization";
import { OSLoadingButton, VerticalStackWidget, FormControl } from "ui-widgets";
import { OSAPIForm, TextFormInput, PhoneNumberFormInput } from "ui-widgets/forms";
import { LoginLink } from "./LoginLink";
import { ForgotPasswordLink } from "./ForgotPasswordLink";
import { AuthFooter } from "./AuthFooter";
import { useAPISignUpForm } from "authentication/services/AuthAPI";
import { SignUpInput } from "lib/schemas";
import { GoogleSignInButton } from "./GoogleSignInButton";

export const AdminSignUpForm = () => {
  const { useAPIFormReturn } = useAPISignUpForm();

  return (
    <SaaSOnlyWrapper>
      <div className="auth-wide-wrapper">
        <div className="auth-form-section">
          <div className="auth-form-box">
            <div className="auth-title-wrapper">
              <h1>Create Account</h1>
              <p>Let's get you setup right away!</p>
            </div>

            <div className="form-fields-A">
              <GoogleSignInButton />

              <div className="form-options-seperator">
                <div className="fo-line"></div>
                <div className="fo-text">OR</div>
                <div className="fo-line"></div>
              </div>

              <OSAPIForm useAPIFormReturn={useAPIFormReturn} showSubmitButton={false}>
                <div className="main-form-fields">
                  <TextFormInput<SignUpInput>
                    schema_field_key="email_address"
                    label="Email Address"
                    type="email"
                    fullWidth
                    autoTrim
                  />
                  <TextFormInput<SignUpInput>
                    schema_field_key="confirm_email_address"
                    label="Confirm Email Address"
                    type="email"
                    fullWidth
                    autoTrim
                  />
                  <TextFormInput<SignUpInput>
                    schema_field_key="organization_name"
                    label="Organization Name"
                    fullWidth
                  />
                  <PhoneNumberFormInput<SignUpInput> schema_field_key="phone_number" label="Phone Number" />

                  <FormControl>
                    <VerticalStackWidget>
                      <OSLoadingButton
                        className="button-style-A"
                        variant="contained"
                        size="large"
                        type="submit"
                        color="primary"
                        isLoading={useAPIFormReturn.isSendingDataToAPI}
                      >
                        Sign Up
                      </OSLoadingButton>
                    </VerticalStackWidget>
                  </FormControl>

                  <p className="auth-form-option">
                    <LoginLink />
                    &nbsp; &bull; &nbsp;
                    <ForgotPasswordLink />
                  </p>
                </div>
              </OSAPIForm>
              <AuthFooter />
            </div>
          </div>
        </div>
      </div>
    </SaaSOnlyWrapper>
  );
};
